export const getNumber = (value = 0, { min, max } = {}) => {
  const formattedMin = !!min || min === 0 ? min : null;
  const formattedMax = !!max || max === 0 ? max : null;
  const parsedValue = parseFloat(value) || 0;

  if ((formattedMin || formattedMin === 0) && parsedValue < formattedMin) {
    return formattedMin;
  }

  if ((formattedMax || formattedMax === 0) && formattedMax < parsedValue) {
    return formattedMax;
  }

  return parsedValue;
};

const numberInputDisabledKeys = [69, 107, 109, 110, 188, 190];

export const handleNumberInputKeyDown = event => {
  if (numberInputDisabledKeys.includes(event.keyCode)) {
    event.preventDefault();
  }
};

export const getNumberWithThousandSeparator = number =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatAmount = value => Math.round(value * 100) / 100;

export function normalizeTranslations(translations) {
  const result = {};

  (function convert(obj, current) {
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      const newKey = current ? `${current}.${key}` : key;

      if (value && typeof value === 'object') {
        convert(value, newKey);
      } else {
        result[newKey] = value;
      }
    });
  })(translations);

  return result;
}
export function objectFlip(obj) {
  return Object.keys(obj).reduce((result, key) => {
    const data = { ...result };
    data[obj[key]] = key;
    return data;
  }, {});
}
